// Dependencies imports
import React, { useState } from "react";
import swal from "sweetalert";
import CircularProgress from "@mui/material/CircularProgress";
import { API } from "aws-amplify";
import BackDrop from "@mui/material/Backdrop";

// Local imports
import config from "../../../config/aws-exports";

// Style imports
import Del from "./DeleteSession.module.scss";
import { Constants } from "../../../config/Constants";



const DeleteSession = ({ handleDeleteClose, deleteData, getSessionList}) => {
  const [spin, setSpin] = useState(false);
  //const classes = useStyles();

  const onsubmit = async () => {
    setSpin(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        sid: deleteData.sid,
        atype: 2,
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.EDIT_SESSION,
        bodyParam
      );
      handleDeleteClose();
      getSessionList();
      swal({
        title: "Success",
        text: "Session Deleted successfully",
        icon: "success",
        dangerMode: false,
        closeOnClickOutside: false,
      }).then((willDelete) => {
        if (willDelete) {
          setSpin(false);
          getSessionList();
        }
      });
    } catch (error) {
      swal({
        title: "Oooops!",
        text: "Soomthing wrong!",
        icon: "warning",
        dangerMode: true,
        closeOnClickOutside: false,
      }).then((willDelete) => {
        if (willDelete) {
          setSpin(false);
        }
      });
      console.log("getUserError", error);
    }
  };

  console.log("deletedata", deleteData);
  return (
    <div className={Del.mainpopup}>
      <BackDrop sx={{ color: "#fff" }} open={spin} className={Del.backdrop}>
        <CircularProgress color="inherit" />
      </BackDrop>
      <h3 className={Del.heading}>
        Are you sure you want to delete this session?
      </h3>
      <div className={Del.buttonholder}>
        <button className={Del.buttonyes} onClick={onsubmit}>
          Yes
        </button>
        <button className={Del.buttonno} onClick={handleDeleteClose}>
          No
        </button>
      </div>
    </div>
  );
};

export default DeleteSession;
